import React from 'react'
import { Badge, Box, Heading, Text, VStack } from '@chakra-ui/react'
import Carousel from '../components/Carousel'

import Footer from '../components/Footer'

import { useParams } from 'react-router-dom'
import { newsData } from '../data/data'
import { useTranslation } from 'react-i18next'
import { formatNewsDate } from '../utils/newsDate'

const SingleNewsPage = () => {
    const { t, i18n } = useTranslation()
    const {id} = useParams<{id: string}>()

    const news = newsData.find((news) => news.id === id)
    if (!news) {
        return (
            <Text textAlign={'center'}>{t('common.noNews')}</Text>
        )
    }

    return (
      <>
        <Box bg={'#f5f5f7'}>
          <Box
            width={'100%'}
            maxW={'1200px'}
            margin={'0 auto'}
            padding={{ base: '11vh 0 8vh', md: '13vh 0 10vh' }}>
            <Box
              width={{ base: '92vw', md: '86vw' }}
              maxW={'1050px'}
              margin={'0 auto'}
              overflow={'hidden'}
              borderRadius={{ base: '14px', md: '20px' }}
              boxShadow={'0 8px 30px rgba(75, 55, 90, 0.12)'}>
              <Carousel
                images={[news.image || '']}
                height={{ base: '50vh', md: '42vh' }}
                objectPosition={{ base: 'center top', md: 'center center' }}
              />
            </Box>

            <VStack
              width={{ base: '88vw', md: '76vw' }}
              maxW={'860px'}
              margin={'0 auto'}
              spacing={4}
              textAlign={'center'}>
              <Badge
                marginTop={{ base: 8, md: 12 }}
                padding={'7px 14px'}
                borderRadius={'full'}
                color={'pink.700'}
                bg={'pink.100'}
                fontSize={'xs'}
                letterSpacing={'0.08em'}
                textTransform={'uppercase'}>
                {t('news.label')}
              </Badge>
              <Heading
                as={'h1'}
                fontSize={{ base: '3xl', md: '5xl' }}
                lineHeight={'1.1'}
                color={'gray.800'}>
                {t(news.title)}
              </Heading>
              <Text
                fontSize={'sm'}
                color={'gray.500'}
                textTransform={'uppercase'}
                letterSpacing={'0.05em'}>
                {t('news.published')} · {formatNewsDate(news.publicationDate, i18n.language)}
              </Text>
            </VStack>

            <Box
              width={{ base: '88vw', md: '72vw' }}
              maxW={'820px'}
              margin={{ base: '7vh auto 0', md: '8vh auto 0' }}
              padding={{ base: '7vw', md: '4vw' }}
              bg={'white'}
              borderRadius={{ base: '22px', md: '30px' }}
              boxShadow={'0 14px 40px rgba(25, 25, 35, 0.07)'}>
              <VStack align={'stretch'} spacing={6}>
                {news.content.map((paragraph, index) => (
                  <Text
                    key={index}
                    fontSize={{ base: 'lg', md: 'xl' }}
                    lineHeight={'1.75'}
                    color={'gray.700'}>
                    {t(paragraph)}
                  </Text>
                ))}
                <Box
                  marginTop={3}
                  padding={{ base: 5, md: 6 }}
                  borderLeft={'4px solid'}
                  borderColor={'pink.300'}
                  borderRadius={'0 14px 14px 0'}
                  bg={'pink.50'}>
                  <Text fontSize={'sm'} color={'gray.500'} textTransform={'uppercase'} letterSpacing={'0.05em'}>
                    {t('news.eventDateLabel')}
                  </Text>
                  <Text marginTop={1} fontSize={{ base: 'xl', md: '2xl' }} fontWeight={'bold'} color={'gray.800'}>
                    {t('news.eventDate')}
                  </Text>
                </Box>
              </VStack>
            </Box>
          </Box>
        </Box>
        <Footer />
      </>
    )
  }

export default SingleNewsPage
